export function clickInsertionPoint({ selectedId, rootId, describe }) {
  const lastChildOf = element => element.childIds.at(-1) ?? null;
  if (!selectedId) {
    const root = describe(rootId);
    if (!root) {
      throw new Error(`clickInsertionPoint: the page root ${rootId} is not loaded`);
    }
    return { containerId: root.id, previousId: lastChildOf(root) };
  }
  const selected = describe(selectedId);
  if (!selected) {
    throw new Error(`clickInsertionPoint: the selected element ${selectedId} is not loaded`);
  }
  if (selected.isContainer) {
    return { containerId: selected.id, previousId: lastChildOf(selected) };
  }
  if (!selected.parentId) {
    throw new Error(`clickInsertionPoint: the selected element ${selectedId} has no container to add next to it in`);
  }
  return { containerId: selected.parentId, previousId: selected.id };
}
